import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DatabaseService } from '../services/database.service';
import { FirebaseUserModel } from '../data-model/user.model';
import { ProfileTypes } from '../utilities';
import { AlertService } from '../services/alert.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;

  validation_messages = {
    'name': [
      { type: 'required', message: 'Nombre es obligatorio.' }
    ],
    'lastname': [
      { type: 'required', message: 'Apellido es obligatorio.' }
    ],
    'email': [
      { type: 'required', message: 'Email es obligatorio.' }
    ],
    'password': [
      { type: 'required', message: 'Contraseña es obligatorio.' }
    ]
  };

  tituloRegistro = 'Registro como usuario estándar';
  profileTypes = ProfileTypes;
  profile = ProfileTypes.Estandar;

  constructor(
    public auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    public databaseService: DatabaseService,
    public alert: AlertService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }
  resetFields() {
    this.registerForm = this.fb.group({
      name: new FormControl('', Validators.required),
      lastname: new FormControl('', Validators.required),
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onSubmit(value) {
    var user = new FirebaseUserModel();
    user.name = value.name;
    user.lastname = value.lastname;
    user.email = value.email;
    user.profile = this.profile;
    var pass = value.password;
    this.auth.signup(user,pass)
      .then(() => {
        this.resetFields();
        this.router.navigate(['/inicio']);
      })
      .catch(error => {
        console.log('error de registro: ', error);
        this.alert.showAlert("Error",error.message,"error");
      })
  }

  tipoRegistro(profile: string) {
    if (profile === ProfileTypes.Estandar) {
      this.tituloRegistro = 'Registro como usuario estándar';
      this.profile = ProfileTypes.Estandar;
    }
    else {
      this.tituloRegistro = 'Registro como usuario creador';
      this.profile = ProfileTypes.Creador;
    }
  }
}
